<template>
  <hm-content title="">
    <div class="goods-details">
      <div class="proinfo flex ">
        <div class="proinfo_img">
          <el-image
            class="img"
            :src="details.spuSlideShowPicList[prizeIndex]"
            alt=""
            :preview-src-list="[details.spuSlideShowPicList[prizeIndex]]"
          />
          <div class="flex flex-between">
            <el-image
              @mouseover.native="hoverImg(i)"
              v-for="(v, i) in details.spuSlideShowPicList"
              :key="i"
              class="thumbnail"
              :src="v"
              alt=""
              :preview-src-list="details.spuSlideShowPicList"
            />
          </div>
        </div>
        <div class="flex-1 proinfo_content" style="margin-top: 70px;">
          <h1 class="goods_name">{{ details.wxshopSpuName }}</h1>
          <div class="summary">
            <p class="summary_price">
              <label style="margin-bottom: 10px; display: inline-block;"
                >售价：</label
              >
              <span class="price"
                ><em>¥{{ details.wxshopPrice }}</em></span
              >
              <label
                style="margin-bottom: 10px; display: inline-block;"
                v-if="details.markingPrice"
                >市场价：</label
              >
              <!---->
              <span
                v-if="details.markingPrice"
                style="color: rgb(136, 136, 136); text-decoration: line-through;"
                >{{ details.markingPrice }}</span
              >
              <!---->
            </p>
            <div class="goodsType">
              <label style="width: 70px;">商品货号：</label>
              <span>{{ details.goodsSn }}</span>
            </div>
            <div class="goodsType">
              <label style="width: 70px;">产地：</label>
              <span>{{ details.nameZh }} </span>
            </div>
            <br />
            <!-- <div class="goodsType">
              <label style="width: 70px;">规格：</label>
              <span>{{ details.specIdGroupName }}</span>
            </div> -->
            <!-- <div class="goodsType">
              <label style="width: 70px;">税费：</label>
              <span
                class="el-tooltip"
                style="cursor: pointer; color: rgb(50, 159, 249);"
                >商家承担<i
                  class="iconfont icon-lvzhou_tishi_wenhao"
                  style="font-size: 13px; color: rgb(50, 159, 249); margin-left: 4px;"
                ></i
              ></span>
            </div> -->
            <p></p>
          </div>
          <div class="summary_info">
            <ul class="flex flex-left">
              <li class="flex-1 ">累计销量 <span class="num">999+</span></li>
              <!-- <li class="flex-1 text-center">
                累计评价 <span class="num">0</span>
              </li> -->
            </ul>
          </div>
        </div>
      </div>
      <div class="mt20 detail_parameter_notice">
        <div class="tab">
          <div class="tab_item">
            <span>商品详情</span>
          </div>
        </div>
        <div class="inner">
          <div class="detail">
            <div class="parameter">
              <ul class="">
                <li>商品名称：{{ details.wxshopSpuName }}</li>
                <li>商品编号：{{ details.goodsSn }}</li>
                <!-- <li>商品规格：60粒/瓶</li> -->
                <li>商品品牌：{{ details.brandName }}</li>
                <!-- <li>商品净重：0.068 kg</li>
                <li>商品毛重：0.1 kg</li> -->
              </ul>
            </div>
            <div>
              <el-image
                class="img"
                src="https://www.191ec.com/static/img/1.170b4ec.jpg"
                alt=""
                :preview-src-list="[]"
              />
            </div>
            <div>
              <div v-html="details.spuDetails"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </hm-content>
</template>

<script>
export default {
  data() {
    return {
      prizeIndex: 0,

      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      wxshopSpuId: this.$route.query.id,
      details: {
        spuSlideShowPicList: []
      }
    };
  },
  created() {},
  mounted() {
    console.log("this.wxshopSpuId: ", this.wxshopSpuId);
    this.queryDetails();
  },
  methods: {
    hoverImg(i) {
      this.prizeIndex = i;
    },
    async queryDetails() {
      if (!this.wxshopSpuId) {
        return;
      }
      const { result } = await this.$store.dispatch("getOverseasGoodsDetail", {
        wxshopSpuId: this.wxshopSpuId
      });
      this.details = result;
      console.log("result: ", result);
    }
  }
};
</script>

<style scoped lang="scss">
.goods-details {
  margin: 0 80px;
  .proinfo_img {
    box-sizing: border-box;
    width: 360px;
    margin-right: 50px;

    .img {
      width: 360px;
      height: 320px;
      border: 1px solid rgb(221, 221, 221);
    }

    .thumbnail {
      width: 78px;
      height: 78px;
      border: 1px solid rgb(221, 221, 221);
    }
  }

  .proinfo_content {
    padding-right: 400px;
    .goods_name {
      color: #666;
      padding-top: 10px;
      line-height: 28px;
      margin-bottom: 10px;
      font: 700 20px Arial, microsoft yahei;
      border-bottom: 1px solid #ddd;
      padding-bottom: 20px;
    }
    .summary {
      min-height: 60px;
      margin-bottom: 14px;
      border-bottom: 1px solid #ddd;
      padding-bottom: 14px;
      .summary_price {
        padding: 10px 0;
        margin-bottom: 20px;
        .price {
          color: #e4393c;
          font-size: 16px;
          margin-right: 10px;
          em {
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
          }
        }
      }
      .summary_price > label {
        color: #888;
        display: inline-block;
        margin-bottom: 10px;
      }
      .goodsType {
        display: inline-block;
        width: 48%;
        color: #888;
        margin: 5px 0;
        font-size: 14px;
        label {
          display: inline-block;
          width: 70px;
          text-align: justify;
          text-align-last: justify;
        }
      }

      .goodsType > label {
        color: #888;
        display: inline-block;
        margin-bottom: 10px;
      }
    }
    .summary_info {
      line-height: 20px;
      font-size: 14px;
      border-bottom: 1px solid #ddd;
      padding-bottom: 10px;
      color: #888;
      .num {
        color: #e4393c;
        font-weight: 700;
        margin-left: 3px;
        font-family: "tahoma, arial, \5FAE\8F6F\96C5\9ED1, sans-serif";
      }
    }
  }

  .detail_parameter_notice {
    .tab {
      padding: 10px;
      z-index: 1000;
      background: #f7f7f7;
      border: 1px solid #ddd;
      border-bottom: 2px solid #e4393c;

      .tab_item {
        color: #c40000;
        font-weight: 700;
      }
    }
    .inner {
      border: 1px solid #ddd;
      .detail {
        padding: 15px 25px 25px;
        .parameter {
          color: #848484;
          font-size: 12px;
          line-height: 1.5;
          cursor: default;
          margin-bottom: 20px;
          border-bottom: 1px solid #ddd;
          padding-bottom: 10px;
          li {
            width: 50%;
            font-size: 13px;
            padding: 4px 0;
          }
        }
      }
    }
  }
}
</style>
